import { styled } from '@mui/material';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { theme } from 'v3/styles/global-styles';

export const Content = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  justifyContent: 'center',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const LeftContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const RightContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',

  '& > *': {
    width: '100%',
  },

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    width: 'auto',

    '& > *': {
      width: 'auto',
    },
  },
}));

export const StyledFlexButton = styled(FlexButton)(() => ({
  width: '100%',

  [theme.breakpoints.up('md')]: {
    width: 'auto',
  },
}));
